import { render, staticRenderFns } from "./usb-lpn-details-comp.vue?vue&type=template&id=1b6cccc8&"
import script from "./js/usb-lpn-details-comp.js?vue&type=script&lang=js&"
export * from "./js/usb-lpn-details-comp.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports